/* eslint-disable */
import axios from 'axios';
import DeepMerge from 'deepmerge';
import PropTypes from 'prop-types';
import React from 'react';

import { PageContext } from '../../../contexts/ContextCreator';
import { EmitMetric } from '../../Analytics/VisibilityPixel/VisibilityPixel';
import ConfirmationPopup from '../../ConfirmationPopup/ConfirmationPopup';
import SuccessPopup from '../../Elements/PopUp/SuccessPopup/SuccessPopup';
import { constructCn } from '../../../utilities/helperFunctions';

import AdminMenu from '../../Management/ContentManagement/AdminMenu';
import ReactionIcons from './ReactionIcons/ReactionIcons';

import './SocialBar.scss';

export const pluralizeUnit = (type, count) => {
    switch (type.toUpperCase()) {
        case 'COMMENT':
        default:
            return count === 1 ? 'Comment' : 'Comments';
        case 'REPLY':
            return count === 1 ? 'Reply' : 'Replies';
    }
};

/**
 * @deprecated
 */
export default class SocialBar extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            isFlagging: false,
            openAdminMenu: false,
            adminMenu: [],
            cmsLink: null,
            shouldShowDeleteModal: false,
            isLoggedIn: false,
        };
    }

    componentDidMount = () => {
        this.setIsLoggedIn();
    };

    setIsLoggedIn = () => {
        const isLoggedIn = this.context.isLoggedIn();
        this.setState({ isLoggedIn });
    };

    onSocialIconClick = (voteType) => {
        if (voteType === 'comment') {
            this.props.onReply(this.props.hash);
            return;
        }

        if (voteType === 'flag' && this.props.flagging.active === false) {
            this.setState({ isFlagging: true });
            return;
        }

        if (voteType === 'delete') {
            EmitMetric({
                community_content_key: `${this.props.type}-${this.props.hash}`,
                misc_event_count: 1,
                misc_event_type: 'delete_content_clicked',
            });
            this.setState({ shouldShowDeleteModal: true });
            return;
        }

        if (voteType === 'edit') {
            EmitMetric({
                community_content_key: `${this.props.type}-${this.props.hash}`,
                misc_event_count: 1,
                misc_event_type: 'edit_content_clicked',
            });
            if (this.props.type === 'community-comment') {
                this.props.setEditingCommentHash(this.props.hash);
                return;
            }
            this.props.onEdit(this.props.hash);
            return;
        }

        if (this.state.isLoggedIn) {
            this.props.onVote(this.props.hash, voteType);
        }
    };

    flagContent = () => {
        this.props.onVote(this.props.hash, 'flag');
        this.setState({ isFlagging: false });
    };

    closePopup = () => {
        this.setState({
            isFlagging: false,
        });
    };

    handleDelete = () => {
        const { hash, type } = this.props;
        this.props.onDelete(type, hash);

        this.handleDeleteModalClose();
    };

    handleDeleteModalClose = () =>
        this.setState({ shouldShowDeleteModal: false });

    closeAdminMenu = () => this.setState({ openAdminMenu: false });

    toggleAdminMenu = async () => {
        let adminMenu = [];
        let cmsLink = null;

        if (!this.state.openAdminMenu) {
            const res = await axios.get(
                `/api/content-management/admin-menu/${this.props.type}/${this.props.hash}`
            );
            adminMenu = res.data.actions;
            cmsLink = res.data.cmsLink;
        }

        this.setState((state) => ({
            adminMenu,
            cmsLink,
            openAdminMenu: !state.openAdminMenu,
        }));
    };

    renderFlagPopup() {
        if (this.state.isFlagging === false || !this.state.isLoggedIn) {
            return null;
        }

        return (
            <SuccessPopup
                title="Flag this item"
                buttonOnClick={() => {
                    this.flagContent();
                }}
                buttonText="Yes, please."
                cancelButtonOnClick={this.closePopup}
                secondaryText="Would you like to submit this item for review by our Community Manager?"
            />
        );
    }

    renderClickToActions = () => {
        const types = {
            liking: 'like',
            commenting: 'comment',
            sharing: 'share',
            flagging: 'flag',
            editing: 'edit',
            deleting: 'delete',
        };

        return Object.keys(types).map((type) => {
            const settings = this.props[type] || {};

            if (settings.enabled) {
                let label = null;

                if (settings.count > 0) {
                    label = (
                        <span className="reactionWord">{settings.count}</span>
                    );
                }

                if (settings.icon === 'comment') {
                    const respondAction =
                        this.props.responseType === 'REPLY'
                            ? 'Reply'
                            : 'Comment';
                    const { count } = settings;

                    const labelText =
                        count > 0
                            ? `${count} ${pluralizeUnit(respondAction, count)}`
                            : respondAction;
                    label = <span className="reactionWord">{labelText}</span>;
                }

                return (
                    <div
                        className="iconDisplay d-flex align-items-center justify-content-center"
                        key={type}
                    >
                        <ReactionIcons
                            useSmallIcon={this.props.useSmallIcon}
                            active={settings.active}
                            type={settings.icon}
                            onClick={() => {
                                this.onSocialIconClick(types[type]);
                            }}
                        />
                        {label}
                    </div>
                );
            }

            return null;
        });
    };

    renderSocialBar(isAdmin) {
        const { className } = this.props;
        const wrapperClassname = constructCn(
            'component-Community-SocialBar',
            className
        );

        return (
            <div className={wrapperClassname}>
                <div className="iconRow">
                    {this.renderFlagPopup()}
                    {this.renderClickToActions()}

                    {isAdmin && this.props.type !== 'jobbing' ? (
                        <AdminMenu
                            hash={this.props.hash}
                            type={this.props.type}
                            contentTitle={this.props.contentTitle}
                            adminMenu={this.state.adminMenu}
                            cmsLink={this.state.cmsLink}
                            openAdminMenu={this.state.openAdminMenu}
                            closeAdminMenu={this.closeAdminMenu}
                            toggleAdminMenu={this.toggleAdminMenu}
                        />
                    ) : null}
                </div>

                {this.state.shouldShowDeleteModal && (
                    <ConfirmationPopup
                        onClose={this.handleDeleteModalClose}
                        cssClass="delete-confirmation"
                        heading={`Are you sure you want to delete this ${
                            this.props.type === 'community-comment'
                                ? 'comment'
                                : 'post'
                        }?`}
                        subheading="This cannot be undone."
                        imageSrc="v1562791783/EditDelete/deletemodule_trashcan.svg"
                        buttonMetas={[
                            {
                                onClickHandler: () => this.handleDelete(),
                                buttonText: 'Yes',
                                buttonType: 'purple-medium-white',
                            },
                            {
                                onClickHandler: () =>
                                    this.handleDeleteModalClose(),
                                buttonText: 'No',
                                buttonType: 'secondary-blue-gray',
                            },
                        ]}
                    />
                )}
            </div>
        );
    }

    render() {
        return this.context.wrapAuth(
            `reactbar-${this.props.hash}`,
            this.renderSocialBar(this.context.isAdmin),
            this.props.metrics
        );
    }
}

SocialBar.contextToProps = (context, hash) => {
    const content = context.getContent(hash);

    if (content.type !== 'community-comment' && !content.reactionBar) {
        console.error('NO REACTION BAR FOUND FOR CONTENT:', hash, content.type); // eslint-disable-line no-console
        return SocialBar.getSocialProps({});
    }

    const rbs = content.reactionBar;
    const commentLabel =
        content.type === 'community-comment' ? 'Reply' : rbs.commenting.label;
    let contentType = content.type;
    let isComment = false;
    let contentHash = content.hash;

    if (content.type === 'community-comment') {
        isComment = true;
        contentType = content.parentContentType;
        contentHash = content.parentContentHash;
    }

    const commentLength = content?.commentCount || 0;

    const isOwnContent =
        content.author?.userId === context?.pageProps?.session?.id;

    let enableFlagging = isComment ? true : rbs.flagging.enabled;
    if (isOwnContent) {
        enableFlagging = false;
    }

    const settings = {
        location: content.location,
        hash,
        type: content.type,
        contentTitle: content.title,
        liking: {
            label: isComment ? 'Like' : rbs.liking.label,
            icon: isComment ? 'like' : rbs.liking.icon,
            enabled: isComment ? true : rbs.liking.enabled,
            count: content.likes,
            active: content.userLiked,
        },
        commenting: {
            label: commentLength === 0 ? commentLabel : '',
            enabled: isComment ? true : rbs.commenting.enabled,
            count: commentLength,
            active: commentLength > 0,
        },
        flagging: {
            label: isComment ? '' : rbs.flagging.label,
            enabled: enableFlagging,
            active: content.userFlagged,
        },
        editing: {
            label: '',
            enabled:
                context?.pageProps?.featureFlags?.unifiedPostBox &&
                content.type !== 'community-comment'
                    ? false
                    : !!content.editable,
            active: false,
            icon: 'edit',
        },
        deleting: {
            label: '',
            enabled: !!content.deletable,
            active: false,
            icon: 'delete',
        },
        onVote: context.vote,
        onEdit: context.editContentTrigger,
        metrics: {
            login_trigger: 'react',
            community_content_key: `${contentType}-${contentHash}`,
            community_on_comment: isComment,
        },
        onDelete: context.deleteCommunityContent,
        setEditingCommentHash: context.setEditingCommentHash,
        redirectUrl: content.group ? content.group.groupUrl : '/community/feed',
    };

    return SocialBar.getSocialProps(settings);
};

SocialBar.getSocialProps = (simpleProps) => {
    return DeepMerge.all([SocialBar.defaultProps, simpleProps]);
};

SocialBar.contextType = PageContext;

SocialBar.SectionPropShape = PropTypes.shape({
    icon: PropTypes.oneOf([
        'like',
        'comment',
        'share',
        'flag',
        'interested',
        'edit',
    ]),
    enabled: PropTypes.bool.isRequired,
    label: PropTypes.string,
    active: PropTypes.bool,
    count: PropTypes.number,
});

SocialBar.propTypes = {
    hash: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    contentTitle: PropTypes.string,
    onVote: PropTypes.func.isRequired,
    onReply: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    redirectUrl: PropTypes.string,
    location: PropTypes.string,
    /* TODO: FIX */
    /* eslint-disable react/no-unused-prop-types */
    liking: SocialBar.SectionPropShape,
    flagging: SocialBar.SectionPropShape,
    commenting: SocialBar.SectionPropShape,
    editing: SocialBar.SectionPropShape,
    sharing: SocialBar.SectionPropShape,
    /* eslint-enable react/no-unused-prop-types */
    metrics: PropTypes.shape({
        community_content_key: PropTypes.string,
        community_on_comment: PropTypes.bool,
        login_trigger: PropTypes.string,
    }).isRequired,
    setEditingCommentHash: PropTypes.func.isRequired,

    /**
     * enum of type of response
     */
    responseType: PropTypes.oneOf(['REPLY', 'COMMENT']),
    useSmallIcon: PropTypes.bool,
    /**
     * Custom styling to override default
     */
    className: PropTypes.string,
};

SocialBar.defaultProps = {
    contentTitle: undefined,
    redirectUrl: undefined,
    location: undefined,
    useSmallIcon: false,
    liking: {
        icon: 'like',
        enabled: true,
        label: 'Like',
        active: false,
        count: 0,
    },
    flagging: {
        icon: 'flag',
        enabled: true,
        label: '',
        active: false,
        count: 0,
    },
    commenting: {
        icon: 'comment',
        enabled: true,
        label: 'Comments',
        active: false,
        count: 0,
    },
    editing: {
        icon: 'comment',
        enabled: true,
        label: 'Comments',
        active: false,
        count: 0,
    },
    sharing: {
        icon: 'share',
        enabled: false,
        label: 'Share',
        active: false,
        count: 0,
    },
    responseType: 'COMMENT',
    className: '',
};
